import { Agreement } from './agreement';

export class EulaAgreement extends Agreement {
    acceptedDocId: number;
}